import React from 'react'
import styled from 'styled-components'
import ErrorIcon from '../../images/error.svg'

const ErrorWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const ErrorPage: React.FC<{}> = () => {
    return (
        <ErrorWrapper>
            <img src={ErrorIcon} alt="Error" style={{ width: "128px" }} />
            <label>An unexpected error has occured</label>
        </ErrorWrapper>
    )
}

export default ErrorPage